export { default } from "./GoogleClassIcon";
